
export function proxiedImage(url, width, height, stats = false) {
    return `https://asia-northeast1-kyoko-janai.cloudfunctions.net/imageProxyTokyo?url=${encodeURIComponent(url)}&w=${width}&h=${height}`;
}

export default {
    proxiedImage
};